/**
 * Endpoints shared by specialists and consultants.
 */
import { api } from './baseApi';
import type { ProviderFilterOptions } from '../../types/providerProfile';

export const providersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Cities / areas / specialities in use (list filters + form suggestions). */
    getProviderFilterOptions: builder.query<{ data: ProviderFilterOptions }, void>({
      query: () => '/dashboard/providers/filter-options/',
      providesTags: ['Specialists', 'Consultants'],
    }),
  }),
});

export const { useGetProviderFilterOptionsQuery } = providersApi;
